module.exports = __webpack_public_path__ + "img/input_orders.5e74e759.svg";